"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var react_rainbow_components_1 = require("react-rainbow-components");
var emptyMessage_1 = __importDefault(require("./emptyMessage"));
var loading_1 = __importDefault(require("./loading"));
var getFormattedDateTime_1 = __importDefault(require("./helpers/getFormattedDateTime"));
var styled_1 = require("./styled");
var badgeStatusMap = {
    l: 'success',
    landed: 'success',
    a: 'brand',
    active: 'brand',
    c: 'error',
    canceled: 'error',
    d: 'warning',
    diverted: 'warning',
    delayed: 'warning',
    r: 'warning',
    redirected: 'warning',
    no: 'error',
    'not operational': 'error',
    s: 'brand',
    scheduled: 'brand',
    u: 'default',
    unknown: 'default',
};
var statusMap = {
    l: 'landed',
    a: 'active',
    c: 'canceled',
    d: 'diverted',
    no: 'not operational',
    r: 'redirected',
    s: 'scheduled',
    u: 'unknown',
};
function FlightDetails(props) {
    var data = props.data, date = props.date, flightNumber = props.flightNumber, isLoading = props.isLoading;
    var _a = data || {}, updatedAt = _a.updatedAt, departureAirport = _a.departureAirport, departureAirportTimezone = _a.departureAirportTimezone, departureTime = _a.departureTime, arrivalAirport = _a.arrivalAirport, arrivalAirportTimezone = _a.arrivalAirportTimezone, arrivalTime = _a.arrivalTime, direction = _a.direction, _b = _a.status, status = _b === void 0 ? '' : _b;
    var statusVariant = badgeStatusMap[status.toLowerCase()];
    var statusLabel = statusMap[status.toLowerCase()] || status;
    var isUndefined = data === undefined;
    var isNull = data === null;
    if (isLoading) {
        return (react_1.default.createElement(styled_1.StatusContainer, null,
            react_1.default.createElement(loading_1.default, null)));
    }
    if (isUndefined) {
        return null;
    }
    if (isNull) {
        return (react_1.default.createElement(styled_1.StatusContainer, null,
            react_1.default.createElement(emptyMessage_1.default, { date: date })));
    }
    return (react_1.default.createElement(styled_1.StatusContainer, null,
        react_1.default.createElement(styled_1.Row, null,
            react_1.default.createElement(styled_1.FlightInfo, null,
                react_1.default.createElement(styled_1.FlightTitle, null, departureAirport),
                react_1.default.createElement(styled_1.FlightDate, null, getFormattedDateTime_1.default({
                    date: departureTime,
                    timeZone: departureAirportTimezone,
                })),
                react_1.default.createElement(styled_1.Label, null, departureAirportTimezone)),
            react_1.default.createElement(styled_1.StyledPlane, null),
            react_1.default.createElement(styled_1.FlightInfo, null,
                react_1.default.createElement(styled_1.FlightTitle, null, arrivalAirport),
                react_1.default.createElement(styled_1.FlightDate, null, getFormattedDateTime_1.default({
                    date: arrivalTime,
                    timeZone: arrivalAirportTimezone,
                })),
                react_1.default.createElement(styled_1.Label, null, arrivalAirportTimezone))),
        react_1.default.createElement(styled_1.Footer, null,
            react_1.default.createElement(styled_1.Output, null,
                react_1.default.createElement(styled_1.Label, null, "Flight"),
                react_1.default.createElement(styled_1.Value, null, flightNumber)),
            react_1.default.createElement(styled_1.Output, null,
                react_1.default.createElement(styled_1.Label, null, "Updated At"),
                react_1.default.createElement(styled_1.Value, null, getFormattedDateTime_1.default({ date: updatedAt }))),
            react_1.default.createElement(styled_1.Output, null,
                react_1.default.createElement(styled_1.Label, null, direction),
                react_1.default.createElement(react_rainbow_components_1.Badge, { label: statusLabel, size: "small", variant: statusVariant })))));
}
exports.default = FlightDetails;
FlightDetails.propTypes = {
    data: prop_types_1.default.object,
    date: prop_types_1.default.oneOfType([prop_types_1.default.instanceOf(Date), prop_types_1.default.string, prop_types_1.default.number]),
    flightNumber: prop_types_1.default.string,
    isLoading: prop_types_1.default.bool,
};
FlightDetails.defaultProps = {
    data: undefined,
    date: undefined,
    flightNumber: undefined,
    isLoading: false,
};
//# sourceMappingURL=flightDetails.js.map